const vaiMap = (function(){
	/** Private **/
	const desktopWrapper   = document.querySelector('.ps_content_desktop');
	const mobileWrapper    = document.querySelector('.ps_content_mobile');
	const mapWrapper       = document.querySelector('.ps_content_desktop_map_wrapper');
	const infoWrapper      = document.querySelector('.ps_content_desktop_info_wrapper');
	const allMarkers       = {instances:[],domNodes:[]};

	function initiateMarkers(){
		//1. get data from sessionStorage or fetch (axios) em
		if(window.sessionStorage.getItem('vaiMarkers')){
			const rawMarkers = JSON.parse(window.sessionStorage.getItem(('vaiMarkers')));
			showMarkers(rawMarkers);
		}
		else {
		axios.get('/wp-json/vai/v1/locations')
				.then(({data : rawMarkers}) => {
					// Set raw markers to sessionStorage
					window.sessionStorage.vaiMarkers = JSON.stringify(rawMarkers);
					showMarkers(rawMarkers);
				})
				.catch((error) => {
					// Switch to accordion version on error
					console.log(error);
					desktopWrapper.style.display = 'none';
					mobileWrapper.style.display = 'block';
				})
		}
	}

	function showMarkers(rawMarkers){
		allMarkers.instances = rawMarkers.map((rawMarker,index) => new vaiMarker(rawMarker,index));
		allMarkers.instances.forEach(({marker}) => {
			// Add Marker to Dom -> save dom node (marker) in constant
			const markerInDOM = mapWrapper.appendChild(marker.html);

			// Add styling (position) to dom node (marker)
			markerInDOM.style.top = (parseInt(marker.pos[1]) - 1.5) + '%';
			markerInDOM.style.left = marker.pos[0];

			// set click-event for dom node (marker)
			markerInDOM.addEventListener('click',showwMarkerInfo);

			// push dom-node to allMarkers.domNodes
			allMarkers.domNodes.push(markerInDOM);
		});

		// Get index of merzig in allMarkers -> if avaiable show merzig initially
		const indexOfMerzig  = allMarkers.instances.findIndex(instance => instance.info.includes('<h2>Merzig</h2>'));
		if(indexOfMerzig > -1) {
			infoWrapper.innerHTML = allMarkers.instances[indexOfMerzig].info;
			allMarkers.domNodes[indexOfMerzig].classList.add('active');
		}
	}

	function showwMarkerInfo(event) {
		// Get key-related info-html in markerArray
		const {info} = allMarkers.instances[parseInt(event.target.dataset.key)];

		// remove all active classes + add active class to current marker
		allMarkers.domNodes.forEach(marker => marker.classList.remove('active'));
		event.target.classList.add('active');

		anime
			.timeline({
				targets: infoWrapper,
				duration: 750,
			})
			.add({
				opacity: 0,
				scale: 1.05,
				complete: function () {
					infoWrapper.innerHTML = info;
				}
			})
			.add({
				scale: 1,
				opacity: 1,
			});
	}

	/** Public **/
	return initiateMarkers;
})();